import { ArrowRightCircleIcon } from "@heroicons/react/24/outline";
import React from "react";

const OrderDetails = ({ order }) => {
    const { status, paymentUrl, relatedCapsules, shippingAddress, billingAddress, shippingAddressId, billingAddressId, type } = order;

    const handlePayment = () => {
        if (paymentUrl) {
            window.open(paymentUrl, '_blank');
        }
    };

    const handleGoToCapsule = (customerId, capsuleId) => {
        //Open in new tab
        window.open(`/clients/${customerId}/capsule/${capsuleId}`, '_blank');
    }
    console.log(order)
    const isSameAddress = shippingAddressId === billingAddressId;

    return (
        <div className="order-details p-4 bg-base-100 border border-base-300 rounded-lg shadow-lg max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-4 text-primary">Détails de la commande</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                {/* Carte pour les produits */}
                <div className="card p-4 rounded-lg shadow-md  h-fit max-h-80 overflow-auto ">
                    <h3 className="font-semibold">Produits</h3>
                    <ul className="list-none text-sm">
                        {order.products.map((product) => (
                            <li
                                key={product.id}
                                className="flex items-center py-2 border-b last:border-b-0 gap-4"
                            >
                                <img
                                    src={product.imageUrl || '/assets/images/default-product-image.svg'}
                                    alt={product.name}
                                    className="w-10 h-10 object-cover rounded-md"
                                />
                                <div className="flex-1">
                                    <p className="font-medium text-primary">{product.name}</p>
                                    <p className="text-xs ">
                                        Produit ID: {product.wooProductId}
                                    </p>
                                </div>
                                <div className="text-sm">
                                    Qté : {product.order_products.quantity}
                                </div>
                                <div className="text-primary font-semibold">
                                    {product.price} €
                                </div>
                            </li>
                        ))}
                    </ul>
                    {relatedCapsules && relatedCapsules.length > 0 && (
                        <>
                            <div className="divider" />
                            <div className="flex justify-between w-full">

                                <div className="flex flex-col gap-2 w-full">
                                    <p className="text-md font-semibold">Capsules</p>
                                    {relatedCapsules.map((capsule) => (
                                        <div key={capsule.id} className="flex flex-row gap-2 items-center justify-between border-b border-base-300 p-2 rounded-md shadow-sm">
                                            <p className="text-lg text-primary"><span className="text-xs text-base-content">CAPSULE :</span> {capsule.name}</p>
                                            <div className="flex flex-row gap-2">
                                                <p className="text-xs">Physique : {(capsule.configurations[0].configuration.totalPhysique + capsule.configurations[0].configuration.totalOther) || 0}/{capsule.configurations[0].configuration.total || 0}</p>
                                                <p className="text-xs">Effluences : {capsule.configurations[0].configuration.totalEffluence || 0}/{capsule.configurations[0].configuration.total || 0}</p>
                                            </div>
                                            <ArrowRightCircleIcon className="w-6 h-6 cursor-pointer hover:text-primary hover:scale-110 transition-all duration-300 ease-in-out" onClick={() => handleGoToCapsule(capsule.customerId, capsule.id)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                    {!['cancelled', 'completed'].includes(status) && type !== "order_capsule" && paymentUrl && (
                        <button className="btn btn-primary w-full" onClick={handlePayment}>
                            Payer
                        </button>
                    )}
                </div>
                <div className="grid grid-cols-1 gap-4 h-fit w-auto">
                    <div className="card p-4 rounded-lg shadow-md">
                        <h3 className="font-semibold">{isSameAddress ? 'Livraison et Facturation' : 'Adresses'}</h3>
                        {isSameAddress ? (
                            <div>
                                <p>{shippingAddress.street}</p>
                                <p>{shippingAddress.city}</p>
                                <p>{shippingAddress.postcode}</p>
                                <p>{shippingAddress.country}</p>
                            </div>
                        ) : (
                            <>
                                <div className="mb-2">
                                    <h4 className="font-semibold">Livraison</h4>
                                    <p>{shippingAddress.street}</p>
                                    <p>{shippingAddress.city}</p>
                                    <p>{shippingAddress.postcode}</p>
                                    <p>{shippingAddress.country}</p>
                                </div>
                                <div>
                                    <h4 className="font-semibold">Facturation</h4>
                                    <p>{billingAddress.street}</p>
                                    <p>{billingAddress.city}</p>
                                    <p>{billingAddress.postcode}</p>
                                    <p>{billingAddress.country}</p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {/* {relatedCapsules && relatedCapsules.length > 0 && (
                <div className="card  p-4 rounded-lg shadow-md mt-4 max-h-80 overflow-auto w-full">
                    <h3 className="font-semibold mb-2">Détails des Capsules</h3>
                    <div className="flex flex-wrap ">
                        {relatedCapsules.map((capsule, index) => (
                            capsule.configurations && capsule.configurations.length > 0 && (
                                <div key={index} className="w-full  md:w-2/6 px-2 mb-4  ">
                                    <div className=" p-2 bg-base-200 rounded-lg shadow-sm ">
                                        <p className="text-base font-semibold text-primary">Capsule : {capsule.name}</p>
                                        <div className=" max-h-40 overflow-auto">
                                            <div className="flex flex-row p-2">
                                                <p className="text-primary text-xs w-fit basis-3/4 font-medium">Mélange</p>
                                                <p className="text-primary text-xs w-fit  basis-1/4 font-medium">Dilution</p>
                                            </div>
                                            {capsule.configurations[0].configuration.content.map((item, idx) => (
                                                <div key={idx} className="flex flex-rpw mb-1 bg-base-100 p-2 rounded-md shadow-sm">
                                                    <p className="text-primary w-fit basis-3/4 font-medium">{item.mixture.name}</p>
                                                    <p className="text-primary w-fit basis-1/4 font-medium">{item.dilution ? item.dilution.label : item.mixture.defaultDilution.label}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            )} */}
        </div>
    );
};

export default OrderDetails;
